(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tailmind-v2-gallery"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('tailmind-v2-gallery'))customElements.define('tailmind-v2-gallery',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;
const track=this.querySelector('.tm-v2-gallery-track'),buttons=[...this.querySelectorAll('.tm-v2-gallery-thumbs button')];
const go=i=>track.scrollTo({left:Math.max(0,Math.min(buttons.length-1,i))*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
buttons.forEach((b,i)=>b.addEventListener('click',()=>go(i)));
track.addEventListener('scroll',()=>{const index=Math.round(track.scrollLeft/track.clientWidth);buttons.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===index)))},{passive:true});
track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(Math.round(track.scrollLeft/track.clientWidth)+(e.key==='ArrowRight'?1:-1))}});
}});
  } catch(e) { console.error(e); }
})();

})();
